import React from 'react';
import { Section, FadeIn } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  return <Section background="white" data-id="element-179">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-180">
        <FadeIn delay={0.1} data-id="element-181">
          <div data-id="element-182">
            <h3 className="text-2xl font-serif text-[#3D1F2E] mb-6 flex items-center" data-id="element-183">
              <CheckCircle2 className="w-6 h-6 text-[#28A745] mr-3" data-id="element-184" />
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-185">
              {['Compras por impulso (especialmente de noche)', 'Quieres control sin perder tu estilo de vida', 'Estás lista para seguir un sistema simple 14 días'].map((item, i) => <li key={i} className="flex items-start text-[#7A5C6B]" data-id="element-186">
                  <span className="mr-3 text-[#28A745]" data-id="element-187">•</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-188">
          <div data-id="element-189">
            <h3 className="text-2xl font-serif text-[#3D1F2E] mb-6 flex items-center" data-id="element-190">
              <XCircle className="w-6 h-6 text-[#DC3545] mr-3" data-id="element-191" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-192">
              {['Buscas "hacer dinero rápido"', 'No estás dispuesta a poner fricción (aunque sea mínima)', 'Estás en una crisis severa que requiere apoyo profesional inmediato'].map((item, i) => <li key={i} className="flex items-start text-[#7A5C6B]" data-id="element-193">
                  <span className="mr-3 text-[#DC3545]" data-id="element-194">•</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </Section>;
}